import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Title from "../ReusableComponents/title";
import "../../assets/css/accountmetrics.scss";
import { Grid } from "@mui/material";
import { dollarUS, formatDate } from "../../utilities/formatters";
import { ReactComponent as EditIcon } from "../../assets/icons/NewIcons/editIcon.svg";
import { sendAccountInfo } from "../../store/reducers/dashboardReducer";
import CombinedPopup from "../../components/Popups/CombinedPopup"; // Assuming CombinedPopup is the popup component
import { ReactComponent as CopyIcon } from "../../assets/icons/NewIcons/copyIconAM.svg";
import userIcon from "../../assets/icons/NewIcons/userIconNew.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { getProfileInitials, handleCopyToClipboard } from "../../utilities/string";
import { use } from "echarts";
const AccInfo = ({ GeneralInfo, photo }) => {
  const [editable, setEditable] = useState(false);
  const [profileInputValues, setProfileInputValues] = useState({
    accountNumber: "",
    startingBalance: "",
    masterPassword: "",
    startDate: "",
    expiryDate: "",
    leverage: "",
    group: "", // Add group to state
    type: "", // Add type to state
  });
console.log(profileInputValues,GeneralInfo,"profileInputValuesprofileInputValues")
  const user_profile = useSelector((state) => state.user);
  const dispatch = useDispatch();

  console.log(GeneralInfo);

  // Popup state variables
  const [showPopup, setShowPopup] = useState(false);
  const [popupHead, setPopupHead] = useState("");
  const [popupBody, setPopupBody] = useState("");
  const [popupType, setPopupType] = useState(""); // "error" or "success"

  useEffect(() => {
    setProfileInputValues({
      accountNumber: user_profile.current_account || "",
      startingBalance: GeneralInfo?.challenge?.account_balance
        ? dollarUS(GeneralInfo.challenge.account_balance)
        : "0",
      masterPassword: GeneralInfo?.password || "********",
      startDate: GeneralInfo?.start_date
        ? formatDate(GeneralInfo.start_date)
        : "N/A",
      expiryDate: GeneralInfo?.expiry_date
        ? formatDate(GeneralInfo.expiry_date)
        : "N/A",
      leverage: GeneralInfo?.challenge?.Leverage || "-",
      group: GeneralInfo?.group || "N/A", // Update group
      type: GeneralInfo?.type || "N/A", // Update type
    });
  }, [user_profile, GeneralInfo]);

  const handleEditToggle = () => {
    setEditable(!editable);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSaveChanges = () => {
    const updatedFields = {
      login_id: profileInputValues.accountNumber || "",
      investor_password: profileInputValues.masterPassword || "",
      account_balance: profileInputValues.startingBalance || "",
      full_name: profileInputValues.full_name || "",
      email: profileInputValues.email || "",
      photo: profileInputValues.photo || "",
      type: profileInputValues.type || "", // Include type in payload
      group: profileInputValues.group || "", // Include group in payload
      password: profileInputValues.masterPassword || "",
      leverage: profileInputValues.leverage || "",
      start_date: profileInputValues.startDate || "",
      expiry_date: profileInputValues.expiryDate || "",
    };

    // Log the updated payload for debugging
    console.log("Updated Payload", updatedFields);

    // Dispatch the action to save the changes
    dispatch(sendAccountInfo(updatedFields))
      .then((response) => {
        // Success case
        setPopupHead("Success");
        setPopupBody("Your account info has been successfully updated.");
        setPopupType("success");
        setShowPopup(true);
        setEditable(false); // Disable editing mode after successful save
      })
      .catch((error) => {
        // Error case
        setPopupHead("Error");
        setPopupBody(
          error.response?.data?.message ||
            "An error occurred. Please try again."
        );
        setPopupType("error");
        setShowPopup(true);
      });
  };

  return (
    <div className="Container-p-20 ProfileAccInfoContainer">
      <div className="profileInfoWrapper">
        <div className="profileLeftSection">
          <div className="accountInfoProfile">
          <>{getProfileInitials(user_profile?.first_name, user_profile?.last_name)}</>
          </div>
        </div>
        <div className="profileRightSection">
          <div className="profileInfo">
            <div className="ProfileName">
              {user_profile?.full_name || "Name not available"}
            </div>
            <div className="ProfileType">
              {GeneralInfo?.status || "Status not available"}
            </div>
          </div>
          {/* <button onClick={handleEditToggle}>
            <EditIcon />
          </button> */}
        </div>
      </div>
      <div className="profileDetailFormWrapper">
        <Grid container spacing={2} className="profileDetailForm">
          <Grid item xs={12} md={4} className="AccInfoBox">
            <div className="infoInputBox">
              <label className="input-acg">Account number</label>

              <div className="inputWrapper">
                <input
                  type="text"
                  name="accountNumber"
                  value={profileInputValues?.accountNumber}
                  onChange={handleInputChange}
                  disabled={!editable}
                />
                <CopyToClipboard
                  onCopy={() => handleCopyToClipboard("Account Number Copied!")}
                  text={profileInputValues?.accountNumber}
                >
                  <CopyIcon style={{ cursor: "pointer" }} />
                </CopyToClipboard>
              </div>
            </div>
            <div className="infoInputBox">
              <label className="input-acg">Group</label>
              <div className="inputWrapper">
                <input
                  type="text"
                  name="group"
                  value={profileInputValues?.group}
                  onChange={handleInputChange}
                  disabled={!editable}
                />
              </div>
            </div>
            <div className="infoInputBox">
              <label className="input-acg">Type</label>
              <div className="inputWrapper">
                <input
                  type="text"
                  name="type"
                  value={profileInputValues?.type}
                  onChange={handleInputChange}
                  disabled={!editable}
                />
              </div>
            </div>
            <div className="infoInputBox">
              <label className="input-acg">Starting balance</label>

              <div className="inputWrapper">
                <input
                  type="text"
                  name="startingBalance"
                  value={profileInputValues?.startingBalance}
                  onChange={handleInputChange}
                  disabled={!editable}
                />
                <CopyToClipboard
                  onCopy={() =>
                    handleCopyToClipboard("Starting Balance Copied!")
                  }
                  text={profileInputValues?.startingBalance}
                >
                  <CopyIcon style={{ cursor: "pointer" }} />
                </CopyToClipboard>
              </div>
            </div>
            <div className="infoInputBox">
              <label className="input-acg">Master password</label>
              <div className="inputWrapper">
                <input
                  type="text"
                  name="masterPassword"
                  value={profileInputValues?.masterPassword}
                  onChange={handleInputChange}
                  disabled={!editable}
                />
                <CopyToClipboard
                  onCopy={() =>
                    handleCopyToClipboard("Master Password Copied!")
                  }
                  text={profileInputValues?.masterPassword}
                >
                  <CopyIcon style={{ cursor: "pointer" }} />
                </CopyToClipboard>
              </div>
            </div>
            <div className="infoInputBox">
              <label className="input-acg">Account start date</label>
              <div className="inputWrapper">
                <input
                  type="text"
                  name="startDate"
                  value={profileInputValues?.startDate}
                  onChange={handleInputChange}
                  disabled={!editable}
                />
                <CopyToClipboard
                  onCopy={() => handleCopyToClipboard("Start Date Copied!")}
                  text={profileInputValues?.startDate}
                >
                  <CopyIcon style={{ cursor: "pointer" }} />
                </CopyToClipboard>
              </div>
            </div>
            <div className="infoInputBox">
              <label className="input-acg">Account expiry date</label>
              <div className="inputWrapper">
                <input
                  type="text"
                  name="expiryDate"
                  value={profileInputValues?.expiryDate}
                  onChange={handleInputChange}
                  disabled={!editable}
                />
                <CopyToClipboard
                  onCopy={() => handleCopyToClipboard("Start Date Copied!")}
                  text={profileInputValues?.expiryDate}
                >
                  <CopyIcon style={{ cursor: "pointer" }} />
                </CopyToClipboard>
              </div>
            </div>
            <div className="infoInputBox">
              <label className="input-acg">Leverage</label>
              <div className="inputWrapper">
                <input
                  type="text"
                  name="leverage"
                  value={profileInputValues?.leverage}
                  onChange={handleInputChange}
                  disabled={!editable}
                />
              </div>
            </div>
          </Grid>
        </Grid>
        {/* <div className="saveBtnContainer">
          <button
            onClick={handleSaveChanges}
            disabled={!editable}
            className="saveChangesButton"
          >
            Save Changes
          </button>
        </div> */}
      </div>

      {/* Success/Error Popup */}
      {showPopup && (
        <CombinedPopup
          head={popupHead}
          subhead={popupBody}
          type={popupType} // "success" or "error"
          trigger={showPopup} // Boolean to show the popup
          setTrigger={setShowPopup} // Function to close the popup
        />
      )}
    </div>
  );
};

export default AccInfo;
